import _extends from "@babel/runtime/helpers/extends";
import React from 'react';
import { SvgIcon, SvgFill } from '@chegg-ui/svg-icon';
var SunMax = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgIcon, _extends({}, props, {
    ref: ref
  }), /*#__PURE__*/React.createElement(SvgFill, {
    d: "M22 13.822a8.598 8.598 0 1 0 0 17.196 8.598 8.598 0 0 0 0-17.197ZM11.793 22.42c0-5.637 4.57-10.207 10.207-10.207 5.637 0 10.207 4.57 10.207 10.207 0 5.637-4.57 10.206-10.207 10.206-5.637 0-10.207-4.57-10.207-10.206ZM22 .42c.444 0 .804.36.804.804V8.75a.804.804 0 1 1-1.608 0V1.224c0-.444.36-.804.804-.804ZM6.443 6.863a.804.804 0 0 1 1.137 0l5.318 5.318a.804.804 0 0 1-1.137 1.137L6.443 8a.804.804 0 0 1 0-1.137ZM0 22.42c0-.444.36-.804.804-.804H8.33a.804.804 0 1 1 0 1.608H.804A.804.804 0 0 1 0 22.42ZM12.898 31.522a.804.804 0 0 1 0 1.137L7.58 37.977a.804.804 0 0 1-1.137-1.137l5.318-5.318a.804.804 0 0 1 1.137 0ZM22 35.285c.444 0 .804.36.804.805v7.526a.804.804 0 1 1-1.608 0V36.09c0-.445.36-.805.804-.805ZM31.102 31.522a.804.804 0 0 1 1.137 0l5.318 5.318a.804.804 0 0 1-1.137 1.137l-5.318-5.318a.804.804 0 0 1 0-1.137ZM34.865 22.42c0-.444.36-.804.805-.804h7.526a.804.804 0 1 1 0 1.608H35.67a.804.804 0 0 1-.805-.804ZM37.557 6.863a.804.804 0 0 1 0 1.137l-5.318 5.318a.804.804 0 1 1-1.137-1.137l5.318-5.318a.804.804 0 0 1 1.137 0Z",
    fillRule: "evenodd",
    clipRule: "evenodd"
  }));
});
SunMax.displayName = 'SunMax';
SunMax.defaultProps = {
  'aria-label': 'SunMax'
};
export default SunMax;


//////////////////
// WEBPACK FOOTER
// ./node_modules/@chegg/writing-checkout/node_modules/@chegg-ui/horizon-icons/dist/esm/icons/Web/SunMax.js
// module id = 3927
// module chunks = 11